import {
  PayloadPostCategories,
  PayloadPutCategories,
  QueryParamsGetCategories,
  ResponseGetCategories,
  ResponsePostCategories,
  ResponsePutCategories,
  RouteGetCategories,
  RoutePostCategories,
  RoutePutCategories,
} from "@CommonApi/categories";
import {
  PayloadFormPostCategories_categoryId_PdfSummaryExclusions,
  ResponseGetCategories_categoryId_PdfSummaryExclusions,
  ResponsePostCategories_categoryId_PdfSummaryExclusions,
  RouteCategories_categoryId_PdfSummaryExclusions,
} from "@CommonApi/categories/_categoryId_/pdf-summary-exclusions";
import {
  QueryParamsGetAuditLogs,
  ResponseGetAuditLogs,
  RouteGetAuditLogs,
} from "@CommonApi/audit-logs";
import { PayloadPostUsers, ResponsePostUsers, RoutePostUsers } from "@CommonApi/users";
import {
  PayloadPutUsers_userId_,
  ResponsePutUsers_userId_,
  RouteDeleteUsers_userId_,
  RoutePutUsers_userId_,
} from "@CommonApi/users/_userId_";
import {
  PayloadPutUsers_userId_Password,
  RoutePutUsers_userId_Password,
} from "@CommonApi/users/_userId_/password";
import { ResponseGetUsersList, RouteGetUsersList } from "@CommonApi/users/list";
import { PayloadPutAuthPassword, RoutePutAuthPassword } from "@CommonApi/auth/password";
import {
  ResponseGetViolationMerchflow_merchflowId_,
  RouteGetViolationMerchflow_merchflowId_,
} from "@CommonApi/violation/merchflow/_merchflowId_";
import {
  OptionalPaginationQueryParams,
  RequiredPaginationQueryParams,
} from "@CommonTypes/backend/pagination";
import { isAxiosError, isCancel } from "axios";
import { useLoaders } from "src/components/InlineLoader";
import { useToasts } from "src/components/Toasts";
import { useTranslation } from "src/i18n";
import { normalizeInputsProductsAllQueryParams } from "src/api/inputs/productsAllQueryParams";
import { repeatedBareArrayParamsSerializer } from "src/api/queryParams";
import type { FlowUpdateStorePogTriggerResponse } from "@CommonApi/merchflows/_merchflowId_/flow-update/_storePogTriggerId_";
import { getRequest } from "src/utils";
import { API, deleteRequest, postFormDataRequest, postRequest, putRequest } from "src/utils/axios";
import {
  PayloadPostMerchflow_merchflowId_FlowUpdate,
  ResponsePostMerchflow_merchflowId_FlowUpdate,
  RoutePostMerchflow_merchflowId_FlowUpdate,
} from "@CommonApi/merchflow/_merchflowId_/flow-update";
import {
  ResponseGetMerchflow_merchflowId_FlowUpdateProducts,
  RouteGetMerchflow_merchflowId_FlowUpdateProducts,
} from "@CommonApi/merchflow/_merchflowId_/flow-update/products";
import {
  ParamsGetInputsMasterFixturesAll,
  ResponseGetInputsMasterFixturesAll,
  RouteGetInputsMasterFixturesAll,
} from "@CommonApi/inputs/master-fixtures/all";
import {
  PayloadPutInputsMasterFixtures_masterFixtureId_,
  ResponsePutInputsMasterFixtures_masterFixtureId_,
  RoutePutInputsMasterFixtures_masterFixtureId_,
} from "@CommonApi/inputs/master-fixtures/_masterFixtureId_";
import {
  PayloadPutInputsMasterFixturesByStoreShelf,
  ResponsePutInputsMasterFixturesByStoreShelf,
  RoutePutInputsMasterFixturesByStoreShelf,
} from "@CommonApi/inputs/master-fixtures/by-store-shelf";
import {
  ResponseGetMerchflow_merchflowId_StorePogTriggerAllFinished,
  RouteGetMerchflow_merchflowId_StorePogTriggerAllFinished,
} from "@CommonApi/merchflow/_merchflowId_/store-pog-trigger/all-finished";
import {
  ParamsGetMerchflow_merchflowId_FlowUpdateChangeSummary,
  ResponseGetMerchflow_merchflowId_FlowUpdateChangeSummary,
  RouteGetMerchflow_merchflowId_FlowUpdateChangeSummary,
} from "@CommonApi/merchflow/_merchflowId_/flow-update/change-summary";
import { PayloadPostStores, RoutePostStores } from "@CommonApi/stores";
import {
  ParamsGetStoresCategoriesList,
  ResponseGetStoresCategoriesList,
  RouteGetStoresCategoriesList,
} from "@CommonApi/stores/categories/list";
import {
  ParamsGetStoresList,
  ResponseGetStoresList,
  RouteGetStoresList,
} from "@CommonApi/stores/list";
import {
  PayloadPutStores_storeId_BindAll,
  RoutePutStores_storeId_BindAll,
} from "@CommonApi/stores/_storeId_/bind-all";
import {
  PayloadPutStores_storeId_Status,
  RoutePutStores_storeId_Status,
} from "@CommonApi/stores/_storeId_/status";
import {
  ResponseGetPogAnalysis_OutputStorePogId_,
  RouteGetPogAnalysis_OutputStorePogId_,
} from "@CommonApi/pog-analysis/_outputStorePogId_";
import {
  PayloadPutCategories_categoryId_Status,
  RoutePutCategories_categoryId_Status,
} from "@CommonApi/categories/_categoryId_/status";
import {
  PayloadPutMerchflowStorePog_storePogId_,
  ResponseGetMerchflowStorePog_storePogId_,
  ResponsePutMerchflowStorePog_storePogId_,
  RouteGetMerchflowStorePog_storePogId_,
  RoutePutMerchflowStorePog_storePogId_,
} from "@CommonApi/merchflow/store/pog/_storePogId_";
import {
  ResponseGetMerchflowStorePogFixture_storePogId_,
  RouteGetMerchflowStorePogFixture_storePogId_,
} from "@CommonApi/merchflow/store-pogs/_storePogId_/fixtures";
import {
  ResponseGetMerchflowStorePog_storePogId_previousAssortment,
  RouteGetMerchflowStorePog_storePogId_previousAssortment,
} from "@CommonApi/merchflow/store/pog/_storePogId_/previous-assortment";
import {
  ResponseGetMerchflowStorePog_storePogId_previousAssortmentCandidates,
  RouteGetMerchflowStorePog_storePogId_previousAssortmentCandidates,
} from "@CommonApi/merchflow/store/pog/_storePogId_/previous-assortment-candidates";
import {
  ResponsePostMerchflowStorePog_storePogId_MarkDelivered,
  RoutePostMerchflowStorePog_storePogId_MarkDelivered,
} from "@CommonApi/merchflow/store/pog/_storePogId_/mark-delivered";
import {
  ResponsePostMerchflows_MerchflowId_StoresPogsMarkDelivered,
  RoutePostMerchflows_MerchflowId_StoresPogsMarkDelivered,
} from "@CommonApi/merchflows/_merchflowId_/stores/pogs/mark-delivered";
import {
  PayloadPostMerchflowBasePog_basePogId_,
  ResponseGetMerchflowBasePog_basePogId_,
  ResponsePostMerchflowBasePog_basePogId_,
  RouteGetMerchflowBasePog_basePogId_,
  RoutePostMerchflowBasePog_basePogId_,
} from "@CommonApi/merchflow/base-pog/_basePogId_";
import {
  PayloadPutBasePogSelectedStatus,
  RoutePutBasePogSelectedStatus,
} from "@CommonApi/pogger/base-pog/status";
import { ResponseGetAllStoreSummary, RouteGetAllStoreSummary } from "@CommonApi/store-summary";
import {
  PayloadPostMerchflows_merchflowId_ExportsBatch,
  ResponsePostMerchflows_merchflowId_ExportsBatch,
  RoutePostMerchflows_merchflowId_ExportsBatch,
} from "@CommonApi/merchflows/_merchflowId_/exports/batch";
import {
  QueryGetMerchflowsExportsCsvColumns,
  ResponseGetMerchflowsExportsCsvColumns,
  RouteGetMerchflowsExportsCsvColumns,
} from "@CommonApi/merchflows/exports/csv/columns";
import { downloadFileFromUrl, openNativeDownload } from "src/utils/downloadFile";
import {
  isExportBatchPendingStatus,
  pollExportBatchUntilTerminal,
} from "src/api/merchflows/exportBatch";
import {
  pdfExportMessageKeys,
  pdfExportRequestDiagnostic,
  pdfExportRequestFailureCategory,
} from "src/api/merchflows/pdfExportErrors";
import {
  PayloadPutMerchflows_MerchflowId_StoresApprovals,
  RoutePutMerchflows_MerchflowId_StoresApprovals,
} from "@CommonApi/merchflows/_merchflowId_/stores/approvals";
import {
  ResponseGetMerchflowsReviewFlows_merchflowId_,
  RouteGetMerchflowsReviewFlows_merchflowId_,
} from "@CommonApi/merchflows/review/flows/_merchflowId_";
import {
  PayloadPostMerchflowCreatePlanogramTemplate,
  RoutePostMerchflowCreatePlanogramTemplate,
} from "@CommonApi/merchflow/createPlanogramTemplate";
import {
  ResponseGetMerchflows_merchflowId_Details,
  RouteGetMerchflows_merchflowId_Details,
} from "@CommonApi/merchflows/_merchflowId_/details";
import {
  ResponseGetMerchflowsS2_s2SolutionId_,
  RouteGetMerchflowsS2_s2SolutionId_,
} from "@CommonApi/merchflows/s2/_s2SolutionId_";
import {
  ResponseGetMerchflows_merchflowId_BasePog_basePogId_,
  RouteGetMerchflows_merchflowId_BasePog_basePogId_,
} from "@CommonApi/merchflows/_merchflowId_/base-pog/_basePogId_";

import {
  PayloadPutMerchflows_merchflowId_FilterConfigs_filterConfigId_MergeRulesV2,
  ResponsePutMerchflows_merchflowId_FilterConfigs_filterConfigId_MergeRulesV2,
  RoutePutMerchflows_merchflowId_FilterConfigs_filterConfigId_MergeRulesV2,
} from "@CommonApi/merchflows/_merchflowId_/filter-configs/_filterConfig_id/merge-rules-v2";
import {
  PayloadPostAuthLogin,
  ResponsePostAuthLogin,
  RoutePostAuthLogin,
} from "@CommonApi/auth/login";
import { ResponseGetAuthRenewToken, RouteGetAuthRenewToken } from "@CommonApi/auth/renew-token";
import { ResponseGetAuthUser, RouteGetAuthUser } from "@CommonApi/auth/user";
import {
  PayloadPostMercflows_merchflowId_S1,
  ResponsePostMercflows_merchflowId_S1,
  RoutePostMerchflows_merchflowId_S1,
} from "@CommonApi/merchflows/_merchflowId_/s1";

import {
  ResponseGetMerchflows_merchflowId_S0_s0UserTriggerId_,
  RouteGetMerchflows_merchflowId_S0_s0UserTriggerId_,
} from "@CommonApi/merchflows/_merchflowId_/s0/_s0UserTriggerId_";
import {
  ResponseGetMercflows_merchflowId_S1_s1UserTriggerId,
  RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_,
} from "@CommonApi/merchflows/_merchflowId_/s1/_s1UserTriggerId_";
import {
  ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_,
  RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_,
} from "@CommonApi/merchflows/_merchflowId_/s2/_s1UserTriggerId_/s2/_templateId_";
import {
  ResponseGetMerchflows_merchflowId_S2_s2SolutionId_,
  ResponseGetMerchflows_merchflowId_S2_s2SolutionId_logs,
  RouteGetMerchflows_merchflowId_S2_s2SolutionId_,
  RouteGetMerchflows_merchflowId_S2_s2SolutionId_logs,
} from "@CommonApi/merchflows/_merchflowId_/s2/_s2SolutionId_";
import {
  PayloadPostMerchflows_merchflowId_BasePog,
  ResponsePostMerchflows_merchflowId_BasePog,
  RoutePostMerchflows_merchflowId_BasePog,
} from "@CommonApi/merchflows/_merchflowId_/base-pog";
import {
  PayloadPostMerchflowApplyToBases,
  ResponsePostMerchflowApplyToBases,
  RoutePostMerchflowApplyToBases,
} from "@CommonApi/merchflow/apply-to-bases";
import {
  ParamsGetMerchflows_merchflowId_StoresAll,
  ResponseGetMerchflows_merchflowId_StoresAll,
  RouteGetMerchflows_merchflowId_StoresAll,
} from "@CommonApi/merchflows/_merchflowId_/stores/all";
import {
  PayloadPostMerchflows_merchflowId_StoresValidate,
  ResponsePostMerchflows_merchflowId_StoresValidate,
  RoutePostMerchflows_merchflowId_StoresValidate,
} from "@CommonApi/merchflows/_merchflowId_/stores/validate";
import { ResponsePostImportEtlRun, RoutePostImportEtlRun } from "@CommonApi/import-etl/run";

import { PayloadPutInputsProducts, RoutePutInputsProducts } from "@CommonApi/inputs/products";
import {
  ParamsGetInputsProductsAll,
  ResponseGetInputsProductsAll,
  RouteGetInputsProductsAll,
} from "@CommonApi/inputs/products/all";
import {
  ResponseGetMerchflowsFilterConfig_filterConfigId_,
  RouteGetMerchflowsFilterConfig_filterConfigId_,
} from "@CommonApi/merchflows/filter-config/_filterConfigId_";
import {
  PayloadPostMerchflowApplyToBasesByCopyStores,
  ResponsePostMerchflowApplyToBasesByCopyStores,
  RoutePostMerchflowApplyToBasesByCopyStores,
} from "@CommonApi/merchflow/apply-to-bases-by-copy-stores";
import {
  ResponseGetMerchflowBasePog_basePogId_logs,
  RouteGetMerchflowBasePog_basePogId_logs,
} from "@CommonApi/merchflow/base-pog/_basePogId_/logs";
import {
  ResponseGetMerchflowStorePog_storePogId_logs,
  RouteGetMerchflowStorePog_storePogId_logs,
} from "@CommonApi/merchflow/store/pog/_storePogId_/logs";
import {
  ResponseGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl,
  RouteGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl,
} from "@CommonApi/merchflows/_merchflowId_/stores/_storeCode_/original-psa/download-url";
import {
  ResponseGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl,
  RouteGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl,
} from "@CommonApi/merchflows/_merchflowId_/stores/_storeCode_/product-sync-log/download-url";
import {
  PayloadFormPostMerchflowUploadVariantRestrictions,
  ResponsePostMerchflowUploadVariantRestrictions,
  RoutePostMerchflowUploadVariantRestrictions,
} from "@CommonApi/merchflow/upload-variant-restrictions";
import {
  PayloadPostMerchflowParseVariantRestrictions,
  ResponsePostMerchflowParseVariantRestrictions,
  RoutePostMerchflowParseVariantRestrictions,
} from "@CommonApi/merchflow/parse-variant-restrictions";
import {
  PayloadPostMerchflowSaveVariantRestrictions,
  ResponsePostMerchflowSaveVariantRestrictions,
  RoutePostMerchflowSaveVariantRestrictions,
} from "@CommonApi/merchflow/save-variant-restrictions";
import {
  ParamsGetMerchflowStoreFacets,
  ResponseGetMerchflowStoreFacets,
  RouteGetMerchflowStoreFacets,
} from "@CommonApi/merchflow/store-facets";
import {
  ResponsePostInputsProductImages,
  RoutePostInputsProductImages,
} from "@CommonApi/inputs/product-images";
import {
  PayloadPostProjects,
  ResponseGetProjects,
  RouteGetProjects,
  RoutePostProjects,
} from "src/omni-common/projects";
import {
  PayloadPutProjects_projectId_,
  ResponseGetProjects_projectId_,
  RouteGetProjects_projectId_,
  RoutePutProjects_projectId_,
} from "src/omni-common/projects/_projectId_";
import { routeToUrl } from "@CommonUtils/routes";
import {
  ResponseGetMerchflows_merchflowId_Templates,
  ResponseGetMerchflows_merchflowId_TemplatesList,
  RouteGetMerchflows_merchflowId_Templates,
  RouteGetMerchflows_merchflowId_TemplatesList,
} from "@CommonApi/merchflows/_merchflowId_/templates";
import {
  PayloadPutInputsStoreProducts,
  RoutePutInputsStoreProducts,
} from "@CommonApi/inputs/store-products";
import {
  ResponseGetInputsStoreProducts_storeId_,
  RouteGetInputsStoreProducts_storeId_,
} from "@CommonApi/inputs/store-products/_storeId_";
import {
  ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_logs,
  RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_logs,
} from "@CommonApi/merchflows/_merchflowId_/s1/_s1UserTriggerId_/logs";
import {
  ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_logs,
  RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_logs,
} from "@CommonApi/merchflows/_merchflowId_/s1/_s1UserTriggerId_/_templateId_/_templateId_";
import {
  ResponseGetMerchflows_merchflowId_S0_s0SolutionId_logs,
  RouteGetMerchflows_merchflowId_S0_s0SolutionId_logs,
} from "@CommonApi/merchflows/_merchflowId_/s0/_s0SolutionId_/logs";
import {
  PayloadPutMerchantSettings,
  ResponseGetMerchantSettings,
  RouteGetMerchantSettings,
  RoutePutMerchantSettings,
} from "@CommonApi/merchant-settings";
import {
  PayloadFormPostImportJdaBaseline,
  ResponsePostImportJdaBaseline,
  RoutePostImportJdaBaseline,
} from "@CommonApi/import-jda-baseline";
import { ResponseGetReportPowerBI, RouteGetReportPowerBI } from "@CommonApi/report/powerbi";
import {
  ResponsePostReportPowerBIWorkspace,
  RoutePostReportPowerBIWorkspace,
} from "@CommonApi/report/powerbi/workspace";
import {
  ResponseGetReportPowerBIWorkspaceReports,
  RouteGetReportPowerBIWorkspaceReports,
} from "@CommonApi/report/powerbi/workspace/reports";
import { RouteGetCategories_categoryId_DownloadCdtOrder } from "@CommonApi/categories/_categoryId_/download-cdt-order";
import {
  ParamsGetCategories_categoryId_BatchGenerateItems,
  ResponseGetCategories_categoryId_BatchGenerateItems,
  RouteGetCategories_categoryId_BatchGenerateItems,
} from "@CommonApi/categories/_categoryId_/batch-generate-items";
import {
  ResponseGetCategories_categoryId_StoreFixtures,
  RouteGetCategories_categoryId_StoreFixtures,
} from "@CommonApi/categories/_categoryId_/store-fixtures";
import {
  PayloadPostStoresUpdateProducts,
  ResponsePostStoresUpdateProducts,
  RoutePostStoresUpdateProducts,
} from "@CommonApi/stores/update-products";
import {
  ResponseGetMerchflows_merchflowId_UhdBuildingBlocksStores,
  RouteGetMerchflows_merchflowId_UhdBuildingBlocksStores,
} from "@CommonApi/merchflows/_merchflowId_/uhd-building-blocks/stores";
import {
  ResponseGetMerchflows_merchflowId_ExportsBatch_batchId_,
  RouteGetMerchflows_merchflowId_ExportsBatch_batchId_,
} from "@CommonApi/merchflows/_merchflowId_/exports/batch/_batchId_";
import {
  QueryParamsGetAuthSsoLogin,
  ResponseGetAuthSsoLogin,
  RouteGetAuthSsoLogin,
} from "@CommonApi/auth/sso/login";
import {
  ParamsGetCategories_categoryId_Stores_storeId_FixturesPog,
  ParamsPostCategories_categoryId_Stores_storeId_FixturesPog,
  PayloadPostCategories_categoryId_Stores_storeId_FixturesPog,
  ResponseGetCategories_categoryId_Stores_storeId_FixturesPog,
  ResponsePostCategories_categoryId_Stores_storeId_FixturesPog,
  RouteGetCategories_categoryId_Stores_storeId_FixturesPog,
  RoutePostCategories_categoryId_Stores_storeId_FixturesPog,
} from "@CommonApi/categories/_categoryId_/stores/_storeId_/fixturesPog";
import {
  ParamsGetCategories_categoryId_,
  ResponseGetCategories_categoryId_,
  RouteGetCategories_categoryId_,
} from "@CommonApi/categories/_categoryId_";
import {
  ParamsGetStores_storeId_,
  ResponseGetStores_storeId_,
  RouteGetStores_storeId_,
} from "@CommonApi/stores/_storeId_";
import {
  PayloadPostFixturesGuessing,
  QueryParamsGetFixturesGuessing,
  ResponseGetFixturesGuessing,
  ResponsePostFixturesGuessing,
  RouteGetFixturesGuessing,
  RoutePostFixtureGuessing,
} from "@CommonApi/fixtures-guessing";
import {
  ParamsGetFixturesGuessing_fixturesGuessingId_,
  ResponseGetFixturesGuessing_fixturesGuessingId_,
  RouteGetFixturesGuessing_fixturesGuessingId_,
} from "@CommonApi/fixtures-guessing/_fixturesGuessingId_";
import {
  ParamsGetFixturesGuessing_fixturesGuessingId_Logs,
  ResponseGetFixturesGuessing_fixturesGuessingId_Logs,
  RouteGetFixturesGuessing_fixturesGuessingId_Logs,
} from "@CommonApi/fixtures-guessing/_fixturesGuessingId_/logs";
import {
  QueryGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_,
  ResponseGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_,
  RouteGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_,
  RouteGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_Export_,
} from "@CommonApi/merchflows/_merchflowId_/flow-update/_storePogTriggerId_";
import {
  ResponseGetAuthSsoMerchants,
  RouteGetAuthSsoMerchants,
} from "@CommonApi/auth/sso/merchants";
import {
  PayloadPostAuthSsoSwitchMerchant,
  ResponsePostAuthSsoSwitchMerchant,
  RoutePostAuthSsoSwitchMerchant,
} from "@CommonApi/auth/sso/switchMerchant";
import { isFlowUpdateStorePogTriggerError } from "src/utils/flowUpdate";

export * from "./Categories";

export const postAuthLoginReq = (payload: PayloadPostAuthLogin) =>
  postRequest<ResponsePostAuthLogin>(`${API}${RoutePostAuthLogin}`, {
    payload,
  });

export const getAuthUserReq = () => getRequest<ResponseGetAuthUser>(`${API}${RouteGetAuthUser}`);

export const getAuthRenewTokenReq = () =>
  getRequest<ResponseGetAuthRenewToken>(`${API}${RouteGetAuthRenewToken}`);

const getMerchflowDetailsReq = (merchflowId: number) =>
  getRequest<ResponseGetMerchflows_merchflowId_Details>(
    `${API}${RouteGetMerchflows_merchflowId_Details}`,
    {
      params: {
        merchflowId,
      },
    },
  );

export const getCategoriesReq = (queryParams?: QueryParamsGetCategories) =>
  getRequest<ResponseGetCategories>(`${API}${RouteGetCategories}`, {
    queryParams,
  });

const getCategories_categoryId_BatchGenerateItemsReq = (
  params: ParamsGetCategories_categoryId_BatchGenerateItems,
) =>
  getRequest<ResponseGetCategories_categoryId_BatchGenerateItems>(
    `${API}${RouteGetCategories_categoryId_BatchGenerateItems}`,
    {
      params,
    },
  );

const putCategories_categoryId_StatusReq = (
  categoryId: number,
  payload: PayloadPutCategories_categoryId_Status,
) =>
  putRequest(routeToUrl(`${API}${RoutePutCategories_categoryId_Status}`, { categoryId }), {
    payload,
  });

const getStoreCategoriesListReq = (queryParams: ParamsGetStoresCategoriesList) =>
  getRequest<ResponseGetStoresCategoriesList>(`${API}${RouteGetStoresCategoriesList}`, {
    queryParams,
  });

const postCategoriesReq = (payload: PayloadPostCategories) =>
  postRequest<ResponsePostCategories>(`${API}${RoutePostCategories}`, {
    payload,
  });

const putCategoriesReq = (payload: PayloadPutCategories) =>
  putRequest<ResponsePutCategories>(`${API}${RoutePutCategories}`, {
    payload,
  });

const getUsersListReq = () => getRequest<ResponseGetUsersList>(`${API}${RouteGetUsersList}`);

const postUsersReq = (payload: PayloadPostUsers) =>
  postRequest<ResponsePostUsers>(`${API}${RoutePostUsers}`, {
    payload,
  });

const putUsers_userId_Req = (userId: number, payload: PayloadPutUsers_userId_) =>
  putRequest<ResponsePutUsers_userId_>(routeToUrl(`${API}${RoutePutUsers_userId_}`, { userId }), {
    payload,
  });

const putUsers_userId_PasswordReq = (userId: number, payload: PayloadPutUsers_userId_Password) =>
  putRequest<{ message: string }>(
    routeToUrl(`${API}${RoutePutUsers_userId_Password}`, { userId }),
    { payload },
  );

const deleteUsers_userId_Req = (userId: number) =>
  deleteRequest<void>(routeToUrl(`${API}${RouteDeleteUsers_userId_}`, { userId }));

const putAuthPasswordReq = (payload: PayloadPutAuthPassword) =>
  putRequest<{ message: string }>(`${API}${RoutePutAuthPassword}`, { payload });

const getAuditLogsReq = (queryParams: QueryParamsGetAuditLogs) =>
  getRequest<ResponseGetAuditLogs>(`${API}${RouteGetAuditLogs}`, { queryParams });

const getAllStoreSummaryReq = (queryParams?: OptionalPaginationQueryParams) =>
  getRequest<ResponseGetAllStoreSummary>(`${API}${RouteGetAllStoreSummary}`, {
    queryParams,
  });

const getViolationReportReq = (merchflowId: number) =>
  getRequest<ResponseGetViolationMerchflow_merchflowId_>(
    routeToUrl(`${API}${RouteGetViolationMerchflow_merchflowId_}`, {
      merchflowId,
    }),
  );

const getMerchflow_merchflowId_FlowUpdateProductsReq = (merchflowId: number) =>
  getRequest<ResponseGetMerchflow_merchflowId_FlowUpdateProducts>(
    routeToUrl(`${API}${RouteGetMerchflow_merchflowId_FlowUpdateProducts}`, {
      merchflowId,
    }),
  );

const getMerchflowStorePogTriggerAllFinishedReq = (merchflowId: number) =>
  getRequest<ResponseGetMerchflow_merchflowId_StorePogTriggerAllFinished>(
    routeToUrl(`${API}${RouteGetMerchflow_merchflowId_StorePogTriggerAllFinished}`, {
      merchflowId,
    }),
  );

const getInputsFixturesReq = (queryParams: RequiredPaginationQueryParams) =>
  getRequest<ResponseGetInputsMasterFixturesAll>(`${API}${RouteGetInputsMasterFixturesAll}`, {
    queryParams,
  });

export const putInputsMasterFixturesReq = (
  masterFixtureId: string,
  payload: PayloadPutInputsMasterFixtures_masterFixtureId_,
) =>
  putRequest<ResponsePutInputsMasterFixtures_masterFixtureId_>(
    routeToUrl(`${API}${RoutePutInputsMasterFixtures_masterFixtureId_}`, { masterFixtureId }),
    {
      payload,
    },
  );

export const putInputsMasterFixturesByStoreShelfReq = (
  payload: PayloadPutInputsMasterFixturesByStoreShelf,
) =>
  putRequest<ResponsePutInputsMasterFixturesByStoreShelf>(
    `${API}${RoutePutInputsMasterFixturesByStoreShelf}`,
    { payload },
  );

const getMerchflowFlowUpdateChangeSummaryReq = (
  merchflowId: number,
  queryParams: ParamsGetMerchflow_merchflowId_FlowUpdateChangeSummary,
) =>
  getRequest<ResponseGetMerchflow_merchflowId_FlowUpdateChangeSummary>(
    routeToUrl(`${API}${RouteGetMerchflow_merchflowId_FlowUpdateChangeSummary}`, { merchflowId }),
    { queryParams },
  );

const getStoresListReq = (queryParams: ParamsGetStoresList) =>
  getRequest<ResponseGetStoresList>(`${API}${RouteGetStoresList}`, {
    queryParams,
  });

const putStores_storeId_StatusReq = (storeId: number, payload: PayloadPutStores_storeId_Status) =>
  putRequest(routeToUrl(`${API}${RoutePutStores_storeId_Status}`, { storeId }), {
    payload,
  });

const putStores_storeId_CategoriesReq = (
  storeId: number,
  payload: PayloadPutStores_storeId_BindAll,
) =>
  putRequest(routeToUrl(`${API}${RoutePutStores_storeId_BindAll}`, { storeId }), {
    payload,
  });

const postStoresReq = (payload: PayloadPostStores) =>
  postRequest(`${API}${RoutePostStores}`, {
    payload,
  });

export const getMerchflowStorePog_storePogId_Req = (
  storePogId: number,
  includeRanging?: boolean,
) => {
  return getRequest<ResponseGetMerchflowStorePog_storePogId_>(
    `${API}${RouteGetMerchflowStorePog_storePogId_}`,
    {
      params: {
        storePogId,
      },
      queryParams: includeRanging === undefined ? undefined : { includeRanging },
    },
  );
};

export const getMerchflowStorePogFixture_storePogId_Req = (storePogId: number) => {
  return getRequest<ResponseGetMerchflowStorePogFixture_storePogId_>(
    `${API}${RouteGetMerchflowStorePogFixture_storePogId_}`,
    {
      params: {
        storePogId,
      },
    },
  );
};

export const putMerchflowStorePog_storePogId_Req = (
  storePogId: number,
  payload: PayloadPutMerchflowStorePog_storePogId_,
) => {
  return putRequest<ResponsePutMerchflowStorePog_storePogId_>(
    `${API}${RoutePutMerchflowStorePog_storePogId_}`,
    {
      params: {
        storePogId,
      },
      payload,
    },
  );
};

/** `rulesEvidence` adds the base store's `loaders` and `fixtureDividerRows`, for the rules modal. */
export const getMerchflowBasePog_basePogId_Req = (
  basePogId: number,
  { rulesEvidence = false }: { rulesEvidence?: boolean } = {},
) => {
  return getRequest<ResponseGetMerchflowBasePog_basePogId_>(
    `${API}${RouteGetMerchflowBasePog_basePogId_}`,
    {
      params: {
        basePogId,
      },
      queryParams: rulesEvidence ? { rulesEvidence } : undefined,
    },
  );
};

export const getMerchflows_merchflowId_BasePog_basePogId_Req = (
  merchflowId: number,
  basePogId: number,
) => {
  return getRequest<ResponseGetMerchflows_merchflowId_BasePog_basePogId_>(
    `${API}${RouteGetMerchflows_merchflowId_BasePog_basePogId_}`,
    {
      params: {
        merchflowId,
        basePogId,
      },
    },
  );
};

export const postMerchflowBasePogReq = (
  basePogId: number,
  payload: PayloadPostMerchflowBasePog_basePogId_,
) => {
  return postRequest<ResponsePostMerchflowBasePog_basePogId_>(
    `${API}${RoutePostMerchflowBasePog_basePogId_}`,
    {
      payload,
      params: {
        basePogId,
      },
    },
  );
};

export const putMerchflowBasePogStatusReq = (payload: PayloadPutBasePogSelectedStatus) => {
  return putRequest<unknown>(`${API}${RoutePutBasePogSelectedStatus}`, {
    payload,
  });
};

export const postMerchflows_MerchflowId_ExportsBatchReq = (
  merchflowId: number,
  payload: PayloadPostMerchflows_merchflowId_ExportsBatch,
) =>
  postRequest<ResponsePostMerchflows_merchflowId_ExportsBatch>(
    `${API}${RoutePostMerchflows_merchflowId_ExportsBatch}`,
    {
      payload,
      params: {
        merchflowId,
      },
    },
  );

export const getMerchflowsExportsCsvColumnsReq = (
  queryParams?: QueryGetMerchflowsExportsCsvColumns,
) =>
  getRequest<ResponseGetMerchflowsExportsCsvColumns>(
    `${API}${RouteGetMerchflowsExportsCsvColumns}`,
    { queryParams },
  );

export const getMerchflows_MerchflowId_ExportsBatchReq = (merchflowId: number, batchId: number) =>
  getRequest<ResponseGetMerchflows_merchflowId_ExportsBatch_batchId_>(
    `${API}${RouteGetMerchflows_merchflowId_ExportsBatch_batchId_}`,
    {
      params: {
        merchflowId,
        batchId,
      },
    },
  );

const getFlowReviewFilterConfigReq = (merchflowId: number) => {
  return getRequest<ResponseGetMerchflowsReviewFlows_merchflowId_>(
    `${API}${RouteGetMerchflowsReviewFlows_merchflowId_}`,
    { params: { merchflowId } },
  );
};

export const putMerchflows_MerchflowId_StoresApprovalsReq = (
  merchflowId: number,
  payload: PayloadPutMerchflows_MerchflowId_StoresApprovals,
) => {
  return putRequest<unknown>(`${API}${RoutePutMerchflows_MerchflowId_StoresApprovals}`, {
    payload,
    params: {
      merchflowId,
    },
  });
};

export const postMerchflowCreatePlanogramTemplateReq = (
  payload: PayloadPostMerchflowCreatePlanogramTemplate,
) => {
  return postRequest<unknown>(`${API}${RoutePostMerchflowCreatePlanogramTemplate}`, {
    payload,
  });
};

export const getMerchflowS2_s2SolutionId_Req = (s2SolutionId: number) => {
  return getRequest<ResponseGetMerchflowsS2_s2SolutionId_>(
    `${API}${RouteGetMerchflowsS2_s2SolutionId_}`,
    {
      params: {
        s2SolutionId,
      },
    },
  );
};

const putMerchflows_merchflowId_MergeRulesReqV2 = (
  merchflowId: number,
  filterConfigId: number,
  payload: PayloadPutMerchflows_merchflowId_FilterConfigs_filterConfigId_MergeRulesV2,
) =>
  putRequest<ResponsePutMerchflows_merchflowId_FilterConfigs_filterConfigId_MergeRulesV2>(
    `${API}${RoutePutMerchflows_merchflowId_FilterConfigs_filterConfigId_MergeRulesV2}`,
    {
      payload,
      params: {
        merchflowId,
        filterConfigId,
      },
    },
  );

const getMerchflows_merchflowId_S0_s0UserTriggerIdReq = (
  merchflowId: number,
  s0UserTriggerId: number,
) =>
  getRequest<ResponseGetMerchflows_merchflowId_S0_s0UserTriggerId_>(
    `${API}${RouteGetMerchflows_merchflowId_S0_s0UserTriggerId_}`,
    {
      params: {
        merchflowId,
        s0UserTriggerId,
      },
    },
  );

const postMerchflows_merchflowId_S1Req = (
  merchflowId: number,
  payload: PayloadPostMercflows_merchflowId_S1,
) =>
  postRequest<ResponsePostMercflows_merchflowId_S1>(`${API}${RoutePostMerchflows_merchflowId_S1}`, {
    params: {
      merchflowId,
    },
    payload,
  });

const getMerchflows_merchflowId_S1_s1UserTriggerId_Req = (
  merchflowId: number,
  s1UserTriggerId: number,
) =>
  getRequest<ResponseGetMercflows_merchflowId_S1_s1UserTriggerId>(
    `${API}${RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_}`,
    {
      params: {
        merchflowId,
        s1UserTriggerId,
      },
    },
  );

const getMerchflows_MerchflowId_StoresAllReq = (
  merchflowId: number,
  queryParams: ParamsGetMerchflows_merchflowId_StoresAll,
) => {
  return getRequest<ResponseGetMerchflows_merchflowId_StoresAll>(
    `${API}${RouteGetMerchflows_merchflowId_StoresAll}`,
    {
      params: {
        merchflowId,
      },
      queryParams,
    },
  );
};

const getMerchflows_merchflowId_UhdBuildingBlocksCompletedStoresReq = (merchflowId: number) => {
  return getRequest<ResponseGetMerchflows_merchflowId_UhdBuildingBlocksStores>(
    `${API}${RouteGetMerchflows_merchflowId_UhdBuildingBlocksStores}`,
    { params: { merchflowId } },
  );
};

const getMerchflows_merchflowId_S2_s1UserTriggerId_Templates_templateId_Req = (params: {
  merchflowId: number;
  s1UserTriggerId: number;
  templateId: string;
}) => {
  return getRequest<ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_>(
    `${API}${RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_}`,
    {
      params,
    },
  );
};

const getMerchflows_merchflowId_S2_s2SolutionId_Req = (params: {
  merchflowId: number;
  s2SolutionId: number;
}) => {
  return getRequest<ResponseGetMerchflows_merchflowId_S2_s2SolutionId_>(
    `${API}${RouteGetMerchflows_merchflowId_S2_s2SolutionId_}`,
    {
      params,
    },
  );
};

const putBasePogStatusReq = (payload: PayloadPutBasePogSelectedStatus) => {
  return putRequest(`${API}${RoutePutBasePogSelectedStatus}`, {
    payload,
  });
};

const postMerchflows_merchflowId_BasePogReq = (
  merchflowId: number,
  payload: PayloadPostMerchflows_merchflowId_BasePog,
) =>
  postRequest<ResponsePostMerchflows_merchflowId_BasePog>(
    `${API}${RoutePostMerchflows_merchflowId_BasePog}`,
    {
      params: {
        merchflowId,
      },
      payload,
    },
  );

export const postMerchflowStartStorePlanogramsGenerationReq = (
  payload: PayloadPostMerchflowApplyToBases,
) => {
  return postRequest<ResponsePostMerchflowApplyToBases>(`${API}${RoutePostMerchflowApplyToBases}`, {
    payload,
  });
};

export const postMerchflowStartStorePlanogramsCopyToStoresGenerationReq = (
  payload: PayloadPostMerchflowApplyToBasesByCopyStores,
) => {
  return postRequest<ResponsePostMerchflowApplyToBasesByCopyStores>(
    `${API}${RoutePostMerchflowApplyToBasesByCopyStores}`,
    {
      payload,
    },
  );
};

export const getPowerBIReportReq = () =>
  getRequest<ResponseGetReportPowerBI>(`${API}${RouteGetReportPowerBI}`);

export const postImportEtlRunReq = () => {
  return postRequest<ResponsePostImportEtlRun>(`${API}${RoutePostImportEtlRun}`);
};

const getMerchanteSettingsReq = () => {
  return getRequest<ResponseGetMerchantSettings>(`${API}${RouteGetMerchantSettings}`);
};

const getPowerBIWorkspaceReportsReq = () => {
  return getRequest<ResponseGetReportPowerBIWorkspaceReports>(
    `${API}${RouteGetReportPowerBIWorkspaceReports}`,
  );
};

const getInputsProductsAllReq = (queryParams: ParamsGetInputsProductsAll) => {
  return getRequest<ResponseGetInputsProductsAll>(`${API}${RouteGetInputsProductsAll}`, {
    queryParams: normalizeInputsProductsAllQueryParams(queryParams),
    paramsSerializer: repeatedBareArrayParamsSerializer,
  });
};

const getMerchflowByFilterConfigIdReq = (filterConfigId: number) => {
  return getRequest<ResponseGetMerchflowsFilterConfig_filterConfigId_>(
    `${API}${RouteGetMerchflowsFilterConfig_filterConfigId_}`,
    {
      params: { filterConfigId },
    },
  );
};

const putMerchantSettingsReq = (payload: PayloadPutMerchantSettings) => {
  return putRequest<void>(`${API}${RoutePutMerchantSettings}`, {
    payload,
  });
};

const postPowerBIWorkspaceReq = () => {
  return postRequest<ResponsePostReportPowerBIWorkspace>(
    `${API}${RoutePostReportPowerBIWorkspace}`,
  );
};

const putInputsProductsReq = (payload: PayloadPutInputsProducts) => {
  return putRequest<unknown>(`${API}${RoutePutInputsProducts}`, {
    payload,
  });
};

const getMerchflowS1PreLogsReq = (merchflowId: number, s1UserTriggerId: number) => {
  return getRequest<ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_logs>(
    `${API}${RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_logs}`,
    {
      params: { merchflowId, s1UserTriggerId },
    },
  );
};

const getMerchflowS1LogsReq = (
  merchflowId: number,
  s1UserTriggerId: number,
  templateId: string,
) => {
  return getRequest<ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_logs>(
    `${API}${RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_logs}`,
    {
      params: { merchflowId, s1UserTriggerId, templateId },
    },
  );
};

const getMerchflowS2LogsReq = (merchflowId: number, s2SolutionId: number) => {
  return getRequest<ResponseGetMerchflows_merchflowId_S2_s2SolutionId_logs>(
    `${API}${RouteGetMerchflows_merchflowId_S2_s2SolutionId_logs}`,
    {
      params: { merchflowId, s2SolutionId },
    },
  );
};

const getMerchflowBasePogLogsReq = (basePogId: number) => {
  return getRequest<ResponseGetMerchflowBasePog_basePogId_logs>(
    `${API}${RouteGetMerchflowBasePog_basePogId_logs}`,
    {
      params: { basePogId },
    },
  );
};

const getMerchflowStorePogLogsReq = (storePogId: number) => {
  return getRequest<ResponseGetMerchflowStorePog_storePogId_logs>(
    `${API}${RouteGetMerchflowStorePog_storePogId_logs}`,
    {
      params: { storePogId },
    },
  );
};

const getMerchflowStoreOriginalPsaDownloadUrlReq = (merchflowId: number, storeCode: string) => {
  return getRequest<ResponseGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl>(
    `${API}${RouteGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl}`,
    {
      params: { merchflowId, storeCode },
    },
  );
};

const getMerchflowStoreProductSyncLogDownloadUrlReq = (merchflowId: number, storeCode: string) => {
  return getRequest<ResponseGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl>(
    `${API}${RouteGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl}`,
    {
      params: { merchflowId, storeCode },
    },
  );
};

const getPdfSummaryProductExclusionsReq = (categoryId: number) =>
  getRequest<ResponseGetCategories_categoryId_PdfSummaryExclusions>(
    `${API}${RouteCategories_categoryId_PdfSummaryExclusions}`,
    { params: { categoryId } },
  );

const postPdfSummaryProductExclusionsReq = (
  categoryId: number,
  payload: PayloadFormPostCategories_categoryId_PdfSummaryExclusions,
) =>
  postFormDataRequest<ResponsePostCategories_categoryId_PdfSummaryExclusions>(
    `${API}${RouteCategories_categoryId_PdfSummaryExclusions}`,
    { params: { categoryId }, payload },
  );

const postMerchflowUploadVariantRestrictionsReq = (
  payload: PayloadFormPostMerchflowUploadVariantRestrictions,
) => {
  return postFormDataRequest<ResponsePostMerchflowUploadVariantRestrictions>(
    `${API}${RoutePostMerchflowUploadVariantRestrictions}`,
    {
      payload,
    },
  );
};

const getMerchflowStoreFacetsReq = (queryParams: ParamsGetMerchflowStoreFacets) =>
  getRequest<ResponseGetMerchflowStoreFacets>(`${API}${RouteGetMerchflowStoreFacets}`, {
    queryParams,
  });

const postMerchflowParseVariantRestrictionsReq = (
  payload: PayloadPostMerchflowParseVariantRestrictions,
) => {
  return postRequest<ResponsePostMerchflowParseVariantRestrictions>(
    `${API}${RoutePostMerchflowParseVariantRestrictions}`,
    {
      payload,
    },
  );
};

const postMerchflowSaveVariantRestrictionsReq = (
  payload: PayloadPostMerchflowSaveVariantRestrictions,
) => {
  return postRequest<ResponsePostMerchflowSaveVariantRestrictions>(
    `${API}${RoutePostMerchflowSaveVariantRestrictions}`,
    {
      payload,
    },
  );
};

const postProductImagesReq = (images: File[]) => {
  return postFormDataRequest<ResponsePostInputsProductImages>(
    `${API}${RoutePostInputsProductImages}`,
    { payload: { images } },
  );
};

const getProjectsReq = () => {
  return getRequest<ResponseGetProjects>(`${API}${RouteGetProjects}`);
};

const postProjectsReq = (payload: PayloadPostProjects) => {
  return postRequest<void>(`${API}${RoutePostProjects}`, { payload });
};

const putProjects_projectId_Req = (projectId: number, payload: PayloadPutProjects_projectId_) => {
  return putRequest<void>(routeToUrl(`${API}${RoutePutProjects_projectId_}`, { projectId }), {
    payload,
  });
};

const getProjects_projectId_Req = (projectId: number) => {
  return getRequest<ResponseGetProjects_projectId_>(
    routeToUrl(`${API}${RouteGetProjects_projectId_}`, { projectId }),
  );
};

const getMerchflows_merchflowId_templatesList_Req = (merchflowId: number) => {
  return getRequest<ResponseGetMerchflows_merchflowId_TemplatesList>(
    routeToUrl(`${API}${RouteGetMerchflows_merchflowId_TemplatesList}`, { merchflowId }),
  );
};

const getMerchflows_merchflowId_templates_Req = (merchflowId: number) => {
  return getRequest<ResponseGetMerchflows_merchflowId_Templates>(
    routeToUrl(`${API}${RouteGetMerchflows_merchflowId_Templates}`, { merchflowId }),
  );
};

const getMerchflowS0LogsReq = (merchflowId: number, s0SolutionId: number) => {
  return getRequest<ResponseGetMerchflows_merchflowId_S0_s0SolutionId_logs>(
    `${API}${RouteGetMerchflows_merchflowId_S0_s0SolutionId_logs}`,
    {
      params: { merchflowId, s0SolutionId },
    },
  );
};

const isNotFoundResponse = (error: unknown): boolean => {
  if (!error || typeof error !== "object" || !("response" in error)) {
    return false;
  }

  const response = error.response;

  return (
    typeof response === "object" &&
    response !== null &&
    "status" in response &&
    response.status === 404
  );
};

export const useApi = () => {
  const { addLoader, removeLoader } = useLoaders();
  const { toast } = useToasts();
  const { t } = useTranslation("planogramDelivery");
  const { t: tCommon } = useTranslation("common");

  const getFixturesGuessingLogsApi = async (
    params: ParamsGetFixturesGuessing_fixturesGuessingId_Logs,
  ) => {
    let response = null;
    addLoader(RouteGetFixturesGuessing_fixturesGuessingId_Logs);

    try {
      response = (
        await getRequest<ResponseGetFixturesGuessing_fixturesGuessingId_Logs>(
          `${API}${RouteGetFixturesGuessing_fixturesGuessingId_Logs}`,
          { params },
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get fixturesGuessing logs",
        error,
      });
    }

    removeLoader(RouteGetFixturesGuessing_fixturesGuessingId_Logs);
    return response;
  };

  const getFixturesGuessingPogApi = async (
    params: ParamsGetFixturesGuessing_fixturesGuessingId_,
  ) => {
    let response = null;
    addLoader(RouteGetFixturesGuessing_fixturesGuessingId_);

    try {
      response = (
        await getRequest<ResponseGetFixturesGuessing_fixturesGuessingId_>(
          `${API}${RouteGetFixturesGuessing_fixturesGuessingId_}`,
          { params },
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to load fixtures guessing pog",
        error,
      });
    }

    removeLoader(RouteGetFixturesGuessing_fixturesGuessingId_);
    return response;
  };

  const getFixturesGuessingApi = async (queryParams: QueryParamsGetFixturesGuessing) => {
    let response = null;
    addLoader(`GET_${RouteGetFixturesGuessing}`);

    try {
      response = (
        await getRequest<ResponseGetFixturesGuessing>(`${API}${RouteGetFixturesGuessing}`, {
          queryParams,
        })
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to load fixtures guessing stores",
        error,
      });
    }

    removeLoader(`GET_${RouteGetFixturesGuessing}`);
    return response;
  };

  const postFixturesGuessingApi = async (payload: PayloadPostFixturesGuessing) => {
    let response = null;
    addLoader(`POST_${RoutePostFixtureGuessing}`);

    try {
      response = (
        await postRequest<ResponsePostFixturesGuessing>(`${API}${RoutePostFixtureGuessing}`, {
          payload,
        })
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to submit fixtures guessing",
        error,
      });
    }

    removeLoader(`POST_${RoutePostFixtureGuessing}`);
    return response;
  };

  const getCategories_categoryId_Stores_storeId_FixturesPogApi = async (
    params: ParamsGetCategories_categoryId_Stores_storeId_FixturesPog,
  ) => {
    let response = null;
    addLoader(RouteGetCategories_categoryId_Stores_storeId_FixturesPog);

    try {
      response = (
        await getRequest<ResponseGetCategories_categoryId_Stores_storeId_FixturesPog>(
          `${API}${RouteGetCategories_categoryId_Stores_storeId_FixturesPog}`,
          { params },
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to load store fixtures",
        error,
      });
    }

    removeLoader(RouteGetCategories_categoryId_Stores_storeId_FixturesPog);
    return response;
  };

  const postCategories_categoryId_Stores_storeId_FixturesPogApi = async (
    params: ParamsPostCategories_categoryId_Stores_storeId_FixturesPog,
    payload: PayloadPostCategories_categoryId_Stores_storeId_FixturesPog,
  ) => {
    let response = null;
    addLoader(RoutePostCategories_categoryId_Stores_storeId_FixturesPog);

    try {
      response = (
        await postRequest<ResponsePostCategories_categoryId_Stores_storeId_FixturesPog>(
          `${API}${RoutePostCategories_categoryId_Stores_storeId_FixturesPog}`,
          { params, payload },
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to save fixtures",
        error,
      });
    }

    removeLoader(RoutePostCategories_categoryId_Stores_storeId_FixturesPog);
    return response;
  };

  const getMerchantSettingsApi = async () => {
    let response: ResponseGetMerchantSettings | null = null;
    addLoader(RouteGetMerchantSettings);

    try {
      response = (await getMerchanteSettingsReq()).data;
    } catch (error) {
      toast({
        title: "Failed to get merchant settings",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchantSettings);
    return response;
  };

  const getPowerBIWorkspaceReportsApi = async () => {
    let response: ResponseGetReportPowerBIWorkspaceReports | null = null;
    addLoader(RouteGetReportPowerBIWorkspaceReports);

    try {
      response = (await getPowerBIWorkspaceReportsReq()).data;
    } catch (error) {
      if (!isNotFoundResponse(error)) {
        toast({
          title: "Failed to get PowerBI workspace reports",
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          error,
        });
      }
    }

    removeLoader(RouteGetReportPowerBIWorkspaceReports);
    return response;
  };

  const getInputsProductsAllApi = async (queryParams: ParamsGetInputsProductsAll) => {
    let response: ResponseGetInputsProductsAll | null = null;
    addLoader(RouteGetInputsProductsAll);

    try {
      response = (await getInputsProductsAllReq(queryParams)).data;
    } catch (error) {
      toast({
        title: "Failed to load products",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetInputsProductsAll);
    return response;
  };

  const putMerchantSettingsApi = async (payload: PayloadPutMerchantSettings) => {
    let response = false;
    addLoader(RoutePutMerchantSettings);

    try {
      await putMerchantSettingsReq(payload);
      response = true;
    } catch (error) {
      toast({
        title: "Failed to update settings",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePutMerchantSettings);
    return response;
  };

  const getPdfSummaryProductExclusionsApi = async (categoryId: number) => {
    let response: ResponseGetCategories_categoryId_PdfSummaryExclusions | null = null;
    addLoader(RouteCategories_categoryId_PdfSummaryExclusions);

    try {
      response = (await getPdfSummaryProductExclusionsReq(categoryId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to load PDF summary exclusions",
        error,
      });
    }

    removeLoader(RouteCategories_categoryId_PdfSummaryExclusions);
    return response;
  };

  const postPdfSummaryProductExclusionsApi = async (
    categoryId: number,
    payload: PayloadFormPostCategories_categoryId_PdfSummaryExclusions,
  ) => {
    let response: ResponsePostCategories_categoryId_PdfSummaryExclusions | null = null;
    addLoader(RouteCategories_categoryId_PdfSummaryExclusions);

    try {
      response = (await postPdfSummaryProductExclusionsReq(categoryId, payload)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to import PDF summary exclusions",
        error,
      });
    }

    removeLoader(RouteCategories_categoryId_PdfSummaryExclusions);
    return response;
  };

  const postImportJdaBaselineApi = async (payload: PayloadFormPostImportJdaBaseline) => {
    let response: ResponsePostImportJdaBaseline | null = null;
    addLoader(RoutePostImportJdaBaseline);

    try {
      response = (
        await postFormDataRequest<ResponsePostImportJdaBaseline>(
          `${API}${RoutePostImportJdaBaseline}`,
          { payload },
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to import JDA baseline",
        error,
      });
    }

    removeLoader(RoutePostImportJdaBaseline);
    return response;
  };

  const postPowerBIWorkspaceApi = async () => {
    let response: ResponsePostReportPowerBIWorkspace | null = null;
    addLoader(RoutePostReportPowerBIWorkspace);

    try {
      response = (await postPowerBIWorkspaceReq()).data;
    } catch (error) {
      toast({
        title: "Failed to create PowerBI workspace",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePostReportPowerBIWorkspace);
    return response;
  };

  const putInputsProductsApi = async (payload: PayloadPutInputsProducts) => {
    let response = false;
    addLoader(RoutePutInputsProducts);

    try {
      await putInputsProductsReq(payload);
      response = true;
    } catch (error) {
      toast({
        title: "Failed to update products",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePutInputsProducts);
    return response;
  };

  const postImportEtlRunApi = async () => {
    let response: ResponsePostImportEtlRun | null = null;
    addLoader(RoutePostImportEtlRun);

    try {
      response = (await postImportEtlRunReq()).data;
    } catch (error) {
      toast({
        title: "Failed to run ETL for all categories",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePostImportEtlRun);
    return response;
  };

  const postMerchflowStartStorePlanogramsGenerationApi = async (
    payload: PayloadPostMerchflowApplyToBases,
  ) => {
    addLoader(RoutePostMerchflowApplyToBases);
    let result = null;

    try {
      result = (await postMerchflowStartStorePlanogramsGenerationReq(payload)).data
        .store_pog_trigger_id;
    } catch (error) {
      toast({
        title: "Failed to start store planograms generation",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePostMerchflowApplyToBases);
    return result;
  };

  const postMerchflowStartStorePlanogramsCopyToStoresGenerationApi = async (
    payload: PayloadPostMerchflowApplyToBasesByCopyStores,
  ) => {
    addLoader(RoutePostMerchflowApplyToBasesByCopyStores);
    let result = null;

    try {
      result = (await postMerchflowStartStorePlanogramsCopyToStoresGenerationReq(payload)).data
        .store_pog_trigger_id;
    } catch (error) {
      toast({
        title: "Failed to start store planograms generation",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePostMerchflowApplyToBasesByCopyStores);
    return result;
  };

  const getPowerBIReportApi = async () => {
    addLoader("powerBiReportApi");
    let response = null;

    try {
      response = (await getPowerBIReportReq()).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to get PowerBI report", error });
    }

    removeLoader("powerBiReportApi");
    return response;
  };

  const getStorePropStatusApi = async (
    merchflowId: number,
    storePogTriggerId: number,
    query?: QueryGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_,
  ) => {
    addLoader(RouteGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_);
    let response: FlowUpdateStorePogTriggerResponse | null = null;

    try {
      response = (
        await getRequest<ResponseGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_>(
          `${API}${RouteGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_}`,
          {
            params: { merchflowId, storePogTriggerId },
            queryParams: query,
          },
        )
      ).data;
    } catch (error: unknown) {
      const errorResponse: unknown = isAxiosError(error) ? error.response?.data : undefined;

      if (isFlowUpdateStorePogTriggerError(errorResponse)) {
        response = errorResponse;
      } else {
        toast({
          title: "Failed to get store propagation status",
          error,
        });
      }
    }

    removeLoader(RouteGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_);
    return response;
  };

  const downloadFlowUpdateExportApi = async (
    merchflowId: number,
    storePogTriggerId: number,
  ): Promise<string> => {
    const url = `${API}${RouteGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_Export_}`
      .replace(":merchflowId", String(merchflowId))
      .replace(":storePogTriggerId", String(storePogTriggerId));

    const response = await getRequest<string>(url);
    return response.data;
  };

  const putBasePogStatusApi = async (payload: PayloadPutBasePogSelectedStatus) => {
    addLoader(RoutePutBasePogSelectedStatus);

    let success = false;
    try {
      await putBasePogStatusReq(payload);
      success = true;
    } catch (error) {
      toast({
        title: "Failed to update base pog status",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePutBasePogSelectedStatus);
    return success;
  };

  const getS2SolutionApi = async (payload: { merchflowId: number; s2SolutionId: number }) => {
    addLoader(RouteGetMerchflows_merchflowId_S2_s2SolutionId_);
    let response = null;

    try {
      response = (await getMerchflows_merchflowId_S2_s2SolutionId_Req(payload)).data;
    } catch (error) {
      toast({
        title: "Failed to get s2 solution",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_S2_s2SolutionId_);
    return response;
  };

  const getS2SolutionsApi = async (payload: {
    merchflowId: number;
    s1UserTriggerId: number;
    templateId: string;
  }) => {
    addLoader(RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_);
    let response = null;

    try {
      response = (
        await getMerchflows_merchflowId_S2_s1UserTriggerId_Templates_templateId_Req(payload)
      ).data;
    } catch (error) {
      toast({
        title: "Failed to get s2 solutions",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_);
    return response;
  };

  const postLoginApi = async (payload: PayloadPostAuthLogin) => {
    addLoader(RoutePostAuthLogin);
    let response = null;

    try {
      response = (await postAuthLoginReq(payload)).data;
    } catch (error) {
      toast({
        title: "Failed to login",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePostAuthLogin);
    return response;
  };

  const getVerifyUserApi = async () => (await getAuthUserReq()).data;

  const getSsoLoginUrl = async (queryParams: QueryParamsGetAuthSsoLogin) => {
    addLoader(RouteGetAuthSsoLogin);
    let response = null;

    try {
      response = (
        await getRequest<ResponseGetAuthSsoLogin>(`${API}${RouteGetAuthSsoLogin}`, {
          queryParams,
          withCredentials: true,
        })
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get SSO login URL",
        error,
      });
    }

    removeLoader(RouteGetAuthSsoLogin);
    return response;
  };

  const getRenewTokenApi = async () => {
    let response = null;

    try {
      response = (await getAuthRenewTokenReq()).data;
    } catch {
      /* ignored */
    }

    return response;
  };

  const getMerchflowS0Api = async (merchflowId: number, s0UserTriggerId: number) => {
    addLoader(RouteGetMerchflows_merchflowId_S0_s0UserTriggerId_);
    let response = null;

    try {
      response = (
        await getMerchflows_merchflowId_S0_s0UserTriggerIdReq(merchflowId, s0UserTriggerId)
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to load s0 solution",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_S0_s0UserTriggerId_);
    return response;
  };

  const postStartMerchflowS1Api = async (
    merchflowId: number,
    payload: PayloadPostMercflows_merchflowId_S1,
  ) => {
    addLoader(RoutePostMerchflows_merchflowId_S1);
    let response = null;

    try {
      response = (await postMerchflows_merchflowId_S1Req(merchflowId, payload)).data;
    } catch (error) {
      toast({
        title: "Failed to start generating s1",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePostMerchflows_merchflowId_S1);
    return response;
  };

  const getMerchflowS1SolutionsApi = async (merchflowId: number, s1SolutionId: number) => {
    addLoader(RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_);
    let response = null;

    try {
      response = (await getMerchflows_merchflowId_S1_s1UserTriggerId_Req(merchflowId, s1SolutionId))
        .data;
    } catch (error) {
      toast({
        title: "Failed to get s1",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_);
    return response;
  };

  const putMerchflows_merchflowId_MergeRulesApiV2 = async (
    merchflowId: number,
    filterConfigId: number,
    payload: PayloadPutMerchflows_merchflowId_FilterConfigs_filterConfigId_MergeRulesV2,
  ) => {
    addLoader(RoutePutMerchflows_merchflowId_FilterConfigs_filterConfigId_MergeRulesV2);
    let response = null;

    try {
      response = (
        await putMerchflows_merchflowId_MergeRulesReqV2(merchflowId, filterConfigId, payload)
      ).data;
    } catch (error) {
      toast({
        title: "Failed to apply merge rules",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePutMerchflows_merchflowId_FilterConfigs_filterConfigId_MergeRulesV2);
    return response;
  };

  const getMerchflowsS2SolutionApi = async (s2SolutionId: number) => {
    addLoader(RouteGetMerchflowsS2_s2SolutionId_);
    let response = null;

    try {
      response = (await getMerchflowS2_s2SolutionId_Req(s2SolutionId)).data;
    } catch (error) {
      toast({
        title: "Failed to load S2 solution",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflowsS2_s2SolutionId_);
    return response;
  };

  const getMerchflowDetailsApi = async (merchflowId: number) => {
    addLoader(RouteGetMerchflows_merchflowId_Details);
    let response = null;

    try {
      response = (await getMerchflowDetailsReq(merchflowId)).data;
    } catch (error) {
      toast({
        title: "Failed to load merchflow details",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_Details);
    return response;
  };

  const getMerchflowBasePogApi = async (basePogId: number) => {
    let response = null;
    addLoader(RouteGetMerchflowBasePog_basePogId_);

    try {
      response = (await getMerchflowBasePog_basePogId_Req(basePogId)).data;
    } catch (error) {
      toast({
        title: "Failed to get base planogram",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflowBasePog_basePogId_);
    return response;
  };

  const getMerchflowBasePogByMerchflowIdAndBasePogIdApi = async (
    merchflowId: number,
    basePogId: number,
  ) => {
    let response = null;
    addLoader(RouteGetMerchflows_merchflowId_BasePog_basePogId_);

    try {
      response = (await getMerchflows_merchflowId_BasePog_basePogId_Req(merchflowId, basePogId))
        .data;
    } catch (error) {
      toast({
        title: "Failed to get base planogram",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_BasePog_basePogId_);
    return response;
  };

  const putMerchflowBasePogApi = async (
    basePogId: number,
    payload: PayloadPostMerchflowBasePog_basePogId_,
  ) => {
    let newBasePogId: number | null = null;
    addLoader(RoutePostMerchflowBasePog_basePogId_);

    try {
      newBasePogId = (await postMerchflowBasePogReq(basePogId, payload)).data.basePogId;
    } catch (error: unknown) {
      toast({
        title: payload.saveAsNew
          ? "Failed to save new version of base planogram"
          : "Failed to save base planogram",
        error,
      });
    }

    removeLoader(RoutePostMerchflowBasePog_basePogId_);
    return newBasePogId;
  };

  const getMerchflowStorePogApi = async (storePogId: number, includeRanging?: boolean) => {
    let response = null;
    addLoader(RouteGetMerchflowStorePog_storePogId_);

    try {
      response = (await getMerchflowStorePog_storePogId_Req(storePogId, includeRanging)).data;
    } catch (error) {
      toast({
        title: "Failed to get store pog",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflowStorePog_storePogId_);
    return response;
  };

  const getMerchflowStorePogFixtureApi = async (storePogId: number) => {
    let response = null;
    addLoader(RouteGetMerchflowStorePogFixture_storePogId_);

    try {
      response = (await getMerchflowStorePogFixture_storePogId_Req(storePogId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get store pog fixtures",
        error,
      });
    }

    removeLoader(RouteGetMerchflowStorePogFixture_storePogId_);
    return response;
  };

  const putMerchflowStorePogApi = async ({
    storePogId,
    payload,
  }: {
    storePogId: number;
    payload: PayloadPutMerchflowStorePog_storePogId_;
  }) => {
    let response = null;
    addLoader(RoutePutMerchflowStorePog_storePogId_);

    try {
      response = (await putMerchflowStorePog_storePogId_Req(storePogId, payload)).data.store_pog_id;
    } catch (error) {
      toast({
        title: "Failed to save store pog",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePutMerchflowStorePog_storePogId_);
    return response;
  };

  const postMerchflowBasePog_basePogId_StatusApi = async (
    payload: PayloadPutBasePogSelectedStatus,
  ) => {
    let success = false;
    addLoader(RoutePutBasePogSelectedStatus);

    try {
      await putMerchflowBasePogStatusReq(payload);
      success = true;
    } catch (error) {
      toast({
        title: "Failed to update base pog status",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePutBasePogSelectedStatus);
    return success;
  };

  const getCategoriesApi = async (queryParams?: QueryParamsGetCategories) => {
    let response = null;
    addLoader(RouteGetCategories);

    try {
      response = (await getCategoriesReq(queryParams)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load categories", error });
    }

    removeLoader(RouteGetCategories);
    return response;
  };

  const getCategories_categoryId_BatchGenerateItems = async (
    params: ParamsGetCategories_categoryId_BatchGenerateItems,
  ) => {
    let response = null;

    try {
      response = (await getCategories_categoryId_BatchGenerateItemsReq(params)).data;
    } catch (error: unknown) {
      toast({
        title: `Failed to load batchGenerateItems for category ${params.categoryId}`,
        error,
      });
    }
    return response;
  };

  const getCategories_categoryId_StoreFixtures = async (categoryId: number) => {
    let response = null;
    addLoader(RouteGetCategories_categoryId_StoreFixtures);

    try {
      response = (
        await getRequest<ResponseGetCategories_categoryId_StoreFixtures[]>(
          `${API}${RouteGetCategories_categoryId_StoreFixtures}`,
          { params: { categoryId } },
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: `Failed to load store fixtures for category ${categoryId}`,
        error,
      });
    }

    removeLoader(RouteGetCategories_categoryId_StoreFixtures);
    return response;
  };

  const putCategories_categoryId_StatusApi = async (
    categoryId: number,
    payload: PayloadPutCategories_categoryId_Status,
  ) => {
    let response = null;
    addLoader(RoutePutCategories_categoryId_Status);

    try {
      response = (await putCategories_categoryId_StatusReq(categoryId, payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to update category status", error });
    }

    removeLoader(RoutePutCategories_categoryId_Status);
    return response;
  };

  const getStoreCategoriesListApi = async (queryParams: ParamsGetStoresCategoriesList) => {
    let response = null;
    addLoader(RouteGetStoresCategoriesList);

    try {
      response = (await getStoreCategoriesListReq(queryParams)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load store categories", error });
    }

    removeLoader(RouteGetStoresCategoriesList);
    return response;
  };

  const postAddCategoryApi = async (payload: PayloadPostCategories) => {
    let response = null;
    addLoader(RoutePostCategories);

    try {
      response = (await postCategoriesReq(payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to add category", error });
    }

    removeLoader(RoutePostCategories);
    return response;
  };

  const putUpdateCategoryApi = async (payload: PayloadPutCategories) => {
    let response = null;
    addLoader(RoutePutCategories);

    try {
      response = (await putCategoriesReq(payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to update category", error });
    }

    removeLoader(RoutePutCategories);
    return response;
  };

  const getUsersListApi = async () => {
    let response = null;
    addLoader(RouteGetUsersList);

    try {
      response = (await getUsersListReq()).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load users", error });
    }

    removeLoader(RouteGetUsersList);
    return response;
  };

  const postAddUserApi = async (payload: PayloadPostUsers) => {
    let response = null;
    addLoader(RoutePostUsers);

    try {
      response = (await postUsersReq(payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to add user", error });
    }

    removeLoader(RoutePostUsers);
    return response;
  };

  const putUpdateUserApi = async (userId: number, payload: PayloadPutUsers_userId_) => {
    let response = null;
    addLoader(RoutePutUsers_userId_);

    try {
      response = (await putUsers_userId_Req(userId, payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to update user", error });
    }

    removeLoader(RoutePutUsers_userId_);
    return response;
  };

  const putUserPasswordApi = async (userId: number, payload: PayloadPutUsers_userId_Password) => {
    let response = null;
    addLoader(RoutePutUsers_userId_Password);

    try {
      response = (await putUsers_userId_PasswordReq(userId, payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to reset password", error });
    }

    removeLoader(RoutePutUsers_userId_Password);
    return response;
  };

  const deleteUserApi = async (userId: number) => {
    let success = false;
    addLoader(RouteDeleteUsers_userId_);

    try {
      await deleteUsers_userId_Req(userId);
      success = true;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to delete user", error });
    }

    removeLoader(RouteDeleteUsers_userId_);
    return success;
  };

  const putAuthPasswordApi = async (payload: PayloadPutAuthPassword) => {
    let response = null;
    addLoader(RoutePutAuthPassword);

    try {
      response = (await putAuthPasswordReq(payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to change password", error });
    }

    removeLoader(RoutePutAuthPassword);
    return response;
  };

  const getAuditLogsApi = async (queryParams: QueryParamsGetAuditLogs) => {
    let response = null;
    addLoader(RouteGetAuditLogs);

    try {
      response = (await getAuditLogsReq(queryParams)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load audit logs", error });
    }

    removeLoader(RouteGetAuditLogs);
    return response;
  };

  const getViolationReportApi = async (merchflowId: number) => {
    let response = null;
    addLoader(RouteGetViolationMerchflow_merchflowId_);

    try {
      response = (await getViolationReportReq(merchflowId)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load violation report", error });
    }

    removeLoader(RouteGetViolationMerchflow_merchflowId_);
    return response;
  };

  const postFlowUpdateApi = async (
    merchflowId: number,
    payload: PayloadPostMerchflow_merchflowId_FlowUpdate,
  ) => {
    let response = null;
    addLoader(RoutePostMerchflow_merchflowId_FlowUpdate);

    try {
      response = (
        await postRequest<ResponsePostMerchflow_merchflowId_FlowUpdate>(
          routeToUrl(`${API}${RoutePostMerchflow_merchflowId_FlowUpdate}`, {
            merchflowId,
          }),
          {
            payload,
          },
        )
      ).data;
    } catch (error: unknown) {
      toast({ title: "Failed to invoke FlowUpdate", error });
    }

    removeLoader(RoutePostMerchflow_merchflowId_FlowUpdate);
    return response;
  };

  const getUpdateFlowProductsApi = async (merchflowId: number) => {
    let response = null;
    addLoader(RouteGetMerchflow_merchflowId_FlowUpdateProducts);

    try {
      response = (await getMerchflow_merchflowId_FlowUpdateProductsReq(merchflowId)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load update flow available products", error });
    }

    removeLoader(RouteGetMerchflow_merchflowId_FlowUpdateProducts);
    return response;
  };

  const getFixturesApi = async (queryParams: ParamsGetInputsMasterFixturesAll) => {
    let response = null;
    addLoader(RouteGetInputsMasterFixturesAll);

    try {
      response = (await getInputsFixturesReq(queryParams)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load fixtures", error });
    }

    removeLoader(RouteGetInputsMasterFixturesAll);
    return response;
  };

  const putInputsMasterFixturesApi = async (
    masterFixtureId: string,
    payload: PayloadPutInputsMasterFixtures_masterFixtureId_,
  ) => {
    let response = null;
    addLoader(RoutePutInputsMasterFixtures_masterFixtureId_);

    try {
      response = (await putInputsMasterFixturesReq(masterFixtureId, payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to update master fixture", error });
    }

    removeLoader(RoutePutInputsMasterFixtures_masterFixtureId_);
    return response;
  };

  const putInputsMasterFixturesByStoreShelfApi = async (
    payload: PayloadPutInputsMasterFixturesByStoreShelf,
  ) => {
    let response = null;
    addLoader(RoutePutInputsMasterFixturesByStoreShelf);

    try {
      response = (await putInputsMasterFixturesByStoreShelfReq(payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: tCommon("shelfDividers.override.saveFailed"), error });
    }

    removeLoader(RoutePutInputsMasterFixturesByStoreShelf);
    return response;
  };

  const getMerchflowStorePogTriggerAllFinishedApi = async (merchflowId: number) => {
    let response = null;
    addLoader(RouteGetMerchflow_merchflowId_StorePogTriggerAllFinished);

    try {
      response = (await getMerchflowStorePogTriggerAllFinishedReq(merchflowId)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load store pog versions", error });
    }

    removeLoader(RouteGetMerchflow_merchflowId_StorePogTriggerAllFinished);
    return response;
  };

  const getMerchflowFlowUpdateChangeSummaryApi = async (
    merchflowId: number,
    queryParams: ParamsGetMerchflow_merchflowId_FlowUpdateChangeSummary,
  ) => {
    let response = null;
    addLoader(RouteGetMerchflow_merchflowId_FlowUpdateChangeSummary);

    try {
      response = (await getMerchflowFlowUpdateChangeSummaryReq(merchflowId, queryParams)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load change summary", error });
    }

    removeLoader(RouteGetMerchflow_merchflowId_FlowUpdateChangeSummary);
    return response;
  };

  const getStoresListApi = async (queryParams: ParamsGetStoresList) => {
    let response = null;
    addLoader(RouteGetStoresList);

    try {
      response = (await getStoresListReq(queryParams)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load stores", error });
    }

    removeLoader(RouteGetStoresList);
    return response;
  };

  const getMerchflowReviewApi = async (merchflowId: number) => {
    let response = null;
    addLoader(RouteGetMerchflowsReviewFlows_merchflowId_);

    try {
      response = (await getFlowReviewFilterConfigReq(merchflowId)).data[0];
    } catch (error) {
      toast({
        title: "Failed to load review details",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflowsReviewFlows_merchflowId_);
    return response;
  };

  const putStores_storeId_StatusApi = async (
    storeId: number,
    payload: PayloadPutStores_storeId_Status,
  ) => {
    let response = null;
    addLoader(RoutePutStores_storeId_Status);

    try {
      response = (await putStores_storeId_StatusReq(storeId, payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to update store status", error });
    }

    removeLoader(RoutePutStores_storeId_Status);
    return response;
  };

  const putStores_storeId_CategoriesApi = async (
    storeId: number,
    payload: PayloadPutStores_storeId_BindAll,
  ) => {
    let response = null;
    addLoader(RoutePutStores_storeId_BindAll);

    try {
      response = (await putStores_storeId_CategoriesReq(storeId, payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to update store categories", error });
    }

    removeLoader(RoutePutStores_storeId_BindAll);
    return response;
  };

  const postStoresApi = async (payload: PayloadPostStores) => {
    let response = null;
    addLoader(RoutePostStores);

    try {
      response = (await postStoresReq(payload)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to add new store", error });
    }

    removeLoader(RoutePostStores);
    return response;
  };

  const getAllStoreSummaryApi = async (queryParams?: OptionalPaginationQueryParams) => {
    let response = null;
    addLoader(RouteGetAllStoreSummary);

    try {
      response = (await getAllStoreSummaryReq(queryParams)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: "Failed to load store summary", error });
    }

    removeLoader(RouteGetAllStoreSummary);
    return response;
  };

  const postExportBatchPogsApi = async (
    merchflowId: number,
    payload: PayloadPostMerchflows_merchflowId_ExportsBatch,
    onBatchStatusChange?: (batch: ResponsePostMerchflows_merchflowId_ExportsBatch) => void,
    isPollingActive?: () => boolean,
  ) => {
    let response = null;
    let batchId: number | undefined;
    addLoader(RoutePostMerchflows_merchflowId_ExportsBatch);

    try {
      const { data } = await postMerchflows_MerchflowId_ExportsBatchReq(merchflowId, payload);
      batchId = data.batch_id;
      onBatchStatusChange?.(data);

      if (data.url || (payload.type === "pdfV2" && !isExportBatchPendingStatus(data.status))) {
        response = data;
      } else {
        response = await pollExportBatchUntilTerminal({
          type: payload.type,
          getBatch: async () =>
            (await getMerchflows_MerchflowId_ExportsBatchReq(merchflowId, data.batch_id)).data,
          onBatchStatusChange,
          isPollingActive,
        });
      }
    } catch (error) {
      if (payload.type === "pdfV2") {
        console.warn("PDF export request failed", {
          merchflowId,
          batchId,
          ...pdfExportRequestDiagnostic(error),
        });
        toast({
          title:
            batchId === undefined
              ? tCommon(pdfExportMessageKeys[pdfExportRequestFailureCategory(error)])
              : tCommon(pdfExportMessageKeys.status),
          type: "ERROR",
        });
      } else {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        toast({ title: "Failed to export store planograms", error });
      }
    }

    // Done and download the exported file
    if (
      response?.status === "DONE" &&
      response.url &&
      (response.type !== "pdfV2" || !isPollingActive || isPollingActive())
    ) {
      if (response.type === "csv" || response.type === "pdfV2") openNativeDownload(response.url);
      else downloadFileFromUrl(response.url);

      // Exporting failed
    } else if (response?.status === "ERROR") {
      toast({
        title:
          response.type === "pdfV2"
            ? tCommon(pdfExportMessageKeys.failed)
            : "Failed to export store planograms",
        type: "ERROR",
      });
    }

    removeLoader(RoutePostMerchflows_merchflowId_ExportsBatch);
    return response;
  };

  const getMerchflowsExportsCsvColumnsApi = async (
    queryParams?: QueryGetMerchflowsExportsCsvColumns,
  ) => {
    try {
      return (await getMerchflowsExportsCsvColumnsReq(queryParams)).data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      toast({ title: tCommon("storePogExport.csvColumns.loadFailedToast"), error });
      return null;
    }
  };

  const getExportBatchPogsApi = async (merchflowId: number, batchId: number) => {
    try {
      return (await getMerchflows_MerchflowId_ExportsBatchReq(merchflowId, batchId)).data;
    } catch (error) {
      console.warn("PDF ZIP download request failed", {
        merchflowId,
        batchId,
        ...pdfExportRequestDiagnostic(error),
      });
      toast({ title: tCommon(pdfExportMessageKeys.download), type: "ERROR" });
      return null;
    }
  };

  const postMerchflowCreatePlanogramTemplateApi = async (
    payload: PayloadPostMerchflowCreatePlanogramTemplate,
  ) => {
    let success = false;
    addLoader(RoutePostMerchflowCreatePlanogramTemplate);

    try {
      await postMerchflowCreatePlanogramTemplateReq(payload);
      success = true;
    } catch (error) {
      toast({
        title: "Failed to create planogram template",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePostMerchflowCreatePlanogramTemplate);
    return success;
  };

  const putMerchflowApprovalsApi = async (
    merchflowId: number,
    payload: PayloadPutMerchflows_MerchflowId_StoresApprovals,
  ) => {
    let success = false;

    addLoader(RoutePutMerchflows_MerchflowId_StoresApprovals);

    try {
      await putMerchflows_MerchflowId_StoresApprovalsReq(merchflowId, payload);
      success = true;
    } catch (error) {
      toast({
        title: "Failed to update approvals",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePutMerchflows_MerchflowId_StoresApprovals);
    return success;
  };

  const postMarkMerchflowStorePogsAsDeliveredApi = async (merchflowId: number) => {
    let response: ResponsePostMerchflows_MerchflowId_StoresPogsMarkDelivered | null = null;
    addLoader(RoutePostMerchflows_MerchflowId_StoresPogsMarkDelivered);

    try {
      response = (
        await postRequest<ResponsePostMerchflows_MerchflowId_StoresPogsMarkDelivered>(
          routeToUrl(`${API}${RoutePostMerchflows_MerchflowId_StoresPogsMarkDelivered}`, {
            merchflowId,
          }),
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: `Failed to mark merchflow ${merchflowId} as delivered`,
        error,
      });
    } finally {
      removeLoader(RoutePostMerchflows_MerchflowId_StoresPogsMarkDelivered);
    }

    return response;
  };

  const getMerchflowStoresAllApi = async (
    merchflowId: number,
    queryParams: ParamsGetMerchflows_merchflowId_StoresAll,
  ) => {
    let response = null;
    addLoader(RouteGetMerchflows_merchflowId_StoresAll);

    try {
      response = (await getMerchflows_MerchflowId_StoresAllReq(merchflowId, queryParams)).data;
    } catch (error) {
      toast({
        title: "Failed to load all stores",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_StoresAll);
    return response;
  };

  const postMerchflowStoresValidateApi = async (
    merchflowId: number,
    payload: PayloadPostMerchflows_merchflowId_StoresValidate,
  ) => {
    let response: ResponsePostMerchflows_merchflowId_StoresValidate | null = null;
    addLoader(RoutePostMerchflows_merchflowId_StoresValidate);

    try {
      response = (
        await postRequest<ResponsePostMerchflows_merchflowId_StoresValidate>(
          routeToUrl(`${API}${RoutePostMerchflows_merchflowId_StoresValidate}`, {
            merchflowId,
          }),
          {
            payload,
          },
        )
      ).data;
    } catch (error) {
      toast({
        title: "Failed to validate stores",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePostMerchflows_merchflowId_StoresValidate);
    return response;
  };

  const getMerchflowUhdBuildingBlocksCompletedStoresApi = async (merchflowId: number) => {
    let response = null;
    addLoader(RouteGetMerchflows_merchflowId_UhdBuildingBlocksStores);
    try {
      response = (await getMerchflows_merchflowId_UhdBuildingBlocksCompletedStoresReq(merchflowId))
        .data;
    } catch (error) {
      toast({
        title: "Failed to load Auto-Mudmap Engine (UHD) building blocks stores",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }
    removeLoader(RouteGetMerchflows_merchflowId_UhdBuildingBlocksStores);
    return response;
  };

  const postStartMerchflowBasePogApi = async (
    merchflowId: number,
    payload: PayloadPostMerchflows_merchflowId_BasePog,
  ) => {
    let response = null;
    addLoader(RoutePostMerchflows_merchflowId_BasePog);

    try {
      response = (await postMerchflows_merchflowId_BasePogReq(merchflowId, payload)).data;
    } catch (error) {
      toast({
        title: "Failed to create base pog",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        error,
      });
    }

    removeLoader(RoutePostMerchflows_merchflowId_BasePog);
    return response;
  };

  const getMerchflowByFilterConfigIdApi = async (filterConfigId: number) => {
    let response = null;
    addLoader(RouteGetMerchflowsFilterConfig_filterConfigId_);

    try {
      response = (await getMerchflowByFilterConfigIdReq(filterConfigId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to load merchflow details",
        error,
      });
    }

    removeLoader(RouteGetMerchflowsFilterConfig_filterConfigId_);
    return response;
  };

  const getMerchflowS1PreLogsApi = async (merchflowId: number, s1UserTriggerId: number) => {
    let response = null;
    addLoader(RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_logs);

    try {
      response = (await getMerchflowS1PreLogsReq(merchflowId, s1UserTriggerId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get pre-s1(get_features) logs",
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_logs);
    return response;
  };

  const getMerchflowS1LogsApi = async (
    merchflowId: number,
    s1UserTriggerId: number,
    templateId: string,
  ) => {
    let response = null;
    addLoader(RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_logs);

    try {
      response = (await getMerchflowS1LogsReq(merchflowId, s1UserTriggerId, templateId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get s1 logs",
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_logs);
    return response;
  };

  const getMerchflowS2LogsApi = async (merchflowId: number, s2SolutionId: number) => {
    let response = null;
    addLoader(RouteGetMerchflows_merchflowId_S2_s2SolutionId_logs);

    try {
      response = (await getMerchflowS2LogsReq(merchflowId, s2SolutionId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get s2(place_variants) logs",
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_S2_s2SolutionId_logs);
    return response;
  };

  const getMerchflowBasePogLogsApi = async (basePogId: number) => {
    let response = null;
    addLoader(RouteGetMerchflowBasePog_basePogId_logs);

    try {
      response = (await getMerchflowBasePogLogsReq(basePogId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get base pog logs",
        error,
      });
    }

    removeLoader(RouteGetMerchflowBasePog_basePogId_logs);
    return response;
  };

  const getMerchflowStorePogLogsApi = async (storePogId: number) => {
    let response = null;
    addLoader(RouteGetMerchflowStorePog_storePogId_logs);

    try {
      response = (await getMerchflowStorePogLogsReq(storePogId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get store pog logs",
        error,
      });
    }

    removeLoader(RouteGetMerchflowStorePog_storePogId_logs);
    return response;
  };

  const getMerchflowStoreOriginalPsaDownloadUrlApi = async (
    merchflowId: number,
    storeCode: string,
  ) => {
    let response = null;
    addLoader(RouteGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl);

    try {
      response = (await getMerchflowStoreOriginalPsaDownloadUrlReq(merchflowId, storeCode)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get original PSA download URL",
        error,
      });
    }

    removeLoader(RouteGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl);
    return response;
  };

  const getMerchflowStoreProductSyncLogDownloadUrlApi = async (
    merchflowId: number,
    storeCode: string,
  ) => {
    let response = null;
    addLoader(RouteGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl);

    try {
      response = (await getMerchflowStoreProductSyncLogDownloadUrlReq(merchflowId, storeCode)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get product sync log download URL",
        error,
      });
    }

    removeLoader(RouteGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl);
    return response;
  };

  const postMerchflowUploadVariantRestrictionsApi = async (
    payload: PayloadFormPostMerchflowUploadVariantRestrictions,
  ) => {
    addLoader(RoutePostMerchflowUploadVariantRestrictions);
    let response: ResponsePostMerchflowUploadVariantRestrictions | null = null;

    try {
      response = (await postMerchflowUploadVariantRestrictionsReq(payload)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to upload variant restrictions file",
        error,
      });
    }

    removeLoader(RoutePostMerchflowUploadVariantRestrictions);
    return response;
  };

  const getMerchflowStoreFacetsApi = async (queryParams: ParamsGetMerchflowStoreFacets) => {
    addLoader(RouteGetMerchflowStoreFacets);
    let response: ResponseGetMerchflowStoreFacets | null = null;

    try {
      response = (await getMerchflowStoreFacetsReq(queryParams)).data;
    } catch (error: unknown) {
      toast({
        title: t("variantRestrictionDescribe.loadStoreFiltersFailed"),
        error,
      });
    }

    removeLoader(RouteGetMerchflowStoreFacets);
    return response;
  };

  const postMerchflowParseVariantRestrictionsApi = async (
    payload: PayloadPostMerchflowParseVariantRestrictions,
  ) => {
    addLoader(RoutePostMerchflowParseVariantRestrictions);
    let response: ResponsePostMerchflowParseVariantRestrictions | null = null;

    try {
      response = (await postMerchflowParseVariantRestrictionsReq(payload)).data;
    } catch (error: unknown) {
      toast({
        title: t("variantRestrictionDescribe.parseFailedTitle"),
        error,
      });
    }

    removeLoader(RoutePostMerchflowParseVariantRestrictions);
    return response;
  };

  const postMerchflowSaveVariantRestrictionsApi = async (
    payload: PayloadPostMerchflowSaveVariantRestrictions,
  ) => {
    addLoader(RoutePostMerchflowSaveVariantRestrictions);
    let response: ResponsePostMerchflowSaveVariantRestrictions | null = null;

    try {
      response = (await postMerchflowSaveVariantRestrictionsReq(payload)).data;
    } catch (error: unknown) {
      toast({
        title: t("variantRestrictionDescribe.saveFailedTitle"),
        error,
      });
    }

    removeLoader(RoutePostMerchflowSaveVariantRestrictions);
    return response;
  };

  const postProductImagesApi = async (images: File[]) => {
    addLoader(RoutePostInputsProductImages);
    let response: ResponsePostInputsProductImages | null = null;

    try {
      response = (await postProductImagesReq(images)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to upload product images",
        error,
      });
    }

    removeLoader(RoutePostInputsProductImages);
    return response;
  };

  const getProjectsApi = async () => {
    let response = null;
    addLoader("GET_/projects");

    try {
      response = (await getProjectsReq()).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to projects",
        error,
      });
    }

    removeLoader("GET_/projects");
    return response;
  };

  const postProjectsApi = async (payload: PayloadPostProjects) => {
    let response = false;
    addLoader("POST_/projects");

    try {
      await postProjectsReq(payload);
      response = true;
    } catch (error: unknown) {
      toast({
        title: "Failed to insert new project",
        error,
      });
    }

    removeLoader("POST_/projects");
    return response;
  };

  const putProjects_projectId_Api = async (
    projectId: number,
    payload: PayloadPutProjects_projectId_,
  ) => {
    let response = false;
    addLoader("PUT_/projects/:projectId");

    try {
      await putProjects_projectId_Req(projectId, payload);
      response = true;
    } catch (error: unknown) {
      toast({
        title: "Failed to update project",
        error,
      });
    }

    removeLoader("PUT_/projects/:projectId");
    return response;
  };

  const getProjectApi = async (projectId: number) => {
    let response = null;
    addLoader("GET_/projects/:projectId");

    try {
      response = (await getProjects_projectId_Req(projectId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get project",
        error,
      });
    }

    removeLoader("GET_/projects/:projectId");
    return response;
  };

  const getCategories_categoryId_Api = async (params: ParamsGetCategories_categoryId_) => {
    let response = null;
    addLoader(RouteGetCategories_categoryId_);

    try {
      response = (
        await getRequest<ResponseGetCategories_categoryId_>(
          `${API}${RouteGetCategories_categoryId_}`,
          { params },
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get category",
        error,
      });
    }

    removeLoader(RouteGetCategories_categoryId_);
    return response;
  };

  const getStores_storeId_Api = async (params: ParamsGetStores_storeId_) => {
    let response = null;
    addLoader(RouteGetStores_storeId_);

    try {
      response = (
        await getRequest<ResponseGetStores_storeId_>(`${API}${RouteGetStores_storeId_}`, { params })
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get store",
        error,
      });
    }

    removeLoader(RouteGetStores_storeId_);
    return response;
  };

  const getTemplatesApi = async (merchflowId: number) => {
    let response = null;
    addLoader(RouteGetMerchflows_merchflowId_Templates);

    try {
      response = (await getMerchflows_merchflowId_templates_Req(merchflowId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get templates",
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_Templates);
    return response;
  };
  const getTemplatesListApi = async (merchflowId: number) => {
    let response = null;
    addLoader(RouteGetMerchflows_merchflowId_TemplatesList);

    try {
      response = (await getMerchflows_merchflowId_templatesList_Req(merchflowId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to load templates list view",
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_TemplatesList);
    return response;
  };

  const getStoreProductsApi = async ({
    storeId,
    page,
    size,
    search,
    category_code,
    retailer_category_code,
    signal,
  }: {
    storeId: number;
    page?: number;
    size?: number;
    search?: string;
    category_code?: string;
    retailer_category_code?: string;
    signal?: AbortSignal;
  }) => {
    let response = null;
    addLoader(RouteGetInputsStoreProducts_storeId_);

    try {
      response = (
        await getRequest<ResponseGetInputsStoreProducts_storeId_>(
          routeToUrl(`${API}${RouteGetInputsStoreProducts_storeId_}`, { storeId }),
          {
            queryParams: {
              page,
              size,
              search,
              category_code,
              retailer_category_code,
            },
            signal,
          },
        )
      ).data;
    } catch (error: unknown) {
      if (!isCancel(error)) {
        toast({
          title: `Failed to get store ${storeId} products`,
          error,
        });
      }
      throw error;
    } finally {
      removeLoader(RouteGetInputsStoreProducts_storeId_);
    }

    return response;
  };

  const getPreviousAssortmentApi = async ({
    storePogId,
    compareWith,
    signal,
  }: {
    storePogId: number;
    compareWith?: number;
    signal?: AbortSignal;
  }) => {
    let response = null;
    addLoader(RouteGetMerchflowStorePog_storePogId_previousAssortment);

    try {
      response = (
        await getRequest<ResponseGetMerchflowStorePog_storePogId_previousAssortment>(
          routeToUrl(`${API}${RouteGetMerchflowStorePog_storePogId_previousAssortment}`, {
            storePogId,
          }),
          {
            queryParams: compareWith === undefined ? undefined : { compare_with: compareWith },
            signal,
          },
        )
      ).data;
    } catch (error: unknown) {
      if (!isCancel(error)) {
        toast({
          title: `Failed to get previous assortment for store pog ${storePogId}`,
          error,
        });
      }
      throw error;
    } finally {
      removeLoader(RouteGetMerchflowStorePog_storePogId_previousAssortment);
    }

    return response;
  };

  const postMarkStorePogDeliveredApi = async (storePogId: number) => {
    let response: ResponsePostMerchflowStorePog_storePogId_MarkDelivered | null = null;
    addLoader(RoutePostMerchflowStorePog_storePogId_MarkDelivered);

    try {
      response = (
        await postRequest<ResponsePostMerchflowStorePog_storePogId_MarkDelivered>(
          routeToUrl(`${API}${RoutePostMerchflowStorePog_storePogId_MarkDelivered}`, {
            storePogId,
          }),
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: `Failed to mark store pog ${storePogId} as delivered`,
        error,
      });
    } finally {
      removeLoader(RoutePostMerchflowStorePog_storePogId_MarkDelivered);
    }

    return response;
  };

  const getPreviousAssortmentCandidatesApi = async (storePogId: number, search?: string) => {
    let response = null;
    addLoader(RouteGetMerchflowStorePog_storePogId_previousAssortmentCandidates);

    try {
      response = (
        await getRequest<ResponseGetMerchflowStorePog_storePogId_previousAssortmentCandidates>(
          routeToUrl(
            `${API}${RouteGetMerchflowStorePog_storePogId_previousAssortmentCandidates}`,
            { storePogId },
            search ? { search } : undefined,
          ),
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: `Failed to get previous assortment candidates for store pog ${storePogId}`,
        error,
      });
      throw error;
    } finally {
      removeLoader(RouteGetMerchflowStorePog_storePogId_previousAssortmentCandidates);
    }

    return response;
  };

  const putStoreProductsApi = async (payload: PayloadPutInputsStoreProducts) => {
    let response = null;
    addLoader(RoutePutInputsStoreProducts);

    try {
      response = (
        await putRequest<unknown>(routeToUrl(`${API}${RoutePutInputsStoreProducts}`), { payload })
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to update store products",
        error,
      });
    }

    removeLoader(RoutePutInputsStoreProducts);
    return response;
  };

  const getMerchflowS0LogsApi = async (merchflowId: number, s0SolutionId: number) => {
    let response = null;
    addLoader(RouteGetMerchflows_merchflowId_S0_s0SolutionId_logs);

    try {
      response = (await getMerchflowS0LogsReq(merchflowId, s0SolutionId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to get s0 logs",
        error,
      });
    }

    removeLoader(RouteGetMerchflows_merchflowId_S0_s0SolutionId_logs);
    return response;
  };

  const getCategories_categoryId_CdtOrderReq = (categoryId: number) =>
    getRequest<string>(`${API}${RouteGetCategories_categoryId_DownloadCdtOrder}`, {
      params: {
        categoryId,
      },
    });

  const getCdtOrderApi = async (categoryId: number) => {
    let response: string | null = null;
    addLoader(RouteGetCategories_categoryId_DownloadCdtOrder);

    try {
      response = (await getCategories_categoryId_CdtOrderReq(categoryId)).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to download CDT order",
        error: error as Error,
      });
    }

    removeLoader(RouteGetCategories_categoryId_DownloadCdtOrder);
    return response;
  };

  const postStoresUpdateProductsApi = async (payload: PayloadPostStoresUpdateProducts) => {
    let response: ResponsePostStoresUpdateProducts | null = null;
    addLoader(RoutePostStoresUpdateProducts);

    try {
      response = (
        await postFormDataRequest<ResponsePostStoresUpdateProducts>(
          `${API}${RoutePostStoresUpdateProducts}`,
          { payload },
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to update store products",
        error: error as Error,
      });
    }

    removeLoader(RoutePostStoresUpdateProducts);
    return response;
  };

  const getPogSummaryApi = async (outputStorePogId: string) => {
    let response: ResponseGetPogAnalysis_OutputStorePogId_ | null = null;
    addLoader(RouteGetPogAnalysis_OutputStorePogId_);

    try {
      response = (
        await getRequest<ResponseGetPogAnalysis_OutputStorePogId_>(
          `${API}/pog-analysis/${outputStorePogId}`,
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to fetch pog analysis data",
        error: error as Error,
      });
    }

    removeLoader(RouteGetPogAnalysis_OutputStorePogId_);
    return response;
  };

  const getSsoAuthMerchantsApi = async () => {
    let response: ResponseGetAuthSsoMerchants | null = null;
    addLoader(RouteGetAuthSsoMerchants);

    try {
      response = (
        await getRequest<ResponseGetAuthSsoMerchants>(`${API}${RouteGetAuthSsoMerchants}`)
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to fetch merchants",
        error: error as Error,
      });
    }

    removeLoader(RouteGetAuthSsoMerchants);
    return response;
  };

  const postSsoAuthSwitchMerchantApi = async (merchantId: number) => {
    let response: ResponsePostAuthSsoSwitchMerchant | null = null;
    addLoader(RoutePostAuthSsoSwitchMerchant);

    try {
      const payload: PayloadPostAuthSsoSwitchMerchant = { merchantId };
      response = (
        await postRequest<ResponsePostAuthSsoSwitchMerchant>(
          `${API}${RoutePostAuthSsoSwitchMerchant}`,
          { payload },
        )
      ).data;
    } catch (error: unknown) {
      toast({
        title: "Failed to switch merchant for SSO user",
        error: error as Error,
      });
    }

    removeLoader(RoutePostAuthSsoSwitchMerchant);
    return response;
  };

  return {
    postLoginApi,
    getSsoLoginUrl,
    getSsoAuthMerchantsApi,
    postSsoAuthSwitchMerchantApi,
    getVerifyUserApi,
    getRenewTokenApi,
    getMerchflowS0Api,
    postStartMerchflowS1Api,
    getMerchflowS1SolutionsApi,
    getMerchflowsS2SolutionApi,
    getMerchflowDetailsApi,
    getCategoriesApi,
    getCategories_categoryId_BatchGenerateItems,
    getPdfSummaryProductExclusionsApi,
    postPdfSummaryProductExclusionsApi,
    getCategories_categoryId_StoreFixtures,
    getStoreCategoriesListApi,
    getUsersListApi,
    getAuditLogsApi,
    getViolationReportApi,
    getUpdateFlowProductsApi,
    getFixturesApi,
    putInputsMasterFixturesApi,
    putInputsMasterFixturesByStoreShelfApi,
    getMerchflowStorePogTriggerAllFinishedApi,
    getMerchflowFlowUpdateChangeSummaryApi,
    getStoresListApi,
    getMerchflowStorePogApi,
    getMerchflowStorePogFixtureApi,
    getMerchflowBasePogApi,
    getMerchflowBasePogByMerchflowIdAndBasePogIdApi,
    getAllStoreSummaryApi,
    getMerchflowReviewApi,
    getMerchflowStoresAllApi,
    postMerchflowStoresValidateApi,
    getMerchflowUhdBuildingBlocksCompletedStoresApi,
    getMerchflowsExportsCsvColumnsApi,
    postExportBatchPogsApi,
    getExportBatchPogsApi,
    postFlowUpdateApi,
    postAddCategoryApi,
    postAddUserApi,
    putUpdateUserApi,
    putUserPasswordApi,
    deleteUserApi,
    putAuthPasswordApi,
    postStoresApi,
    postMerchflowCreatePlanogramTemplateApi,
    postStartMerchflowBasePogApi,
    postMerchflowUploadVariantRestrictionsApi,
    getMerchflowStoreFacetsApi,
    postMerchflowParseVariantRestrictionsApi,
    postMerchflowSaveVariantRestrictionsApi,
    postProductImagesApi,
    putUpdateCategoryApi,
    putCategories_categoryId_StatusApi,
    putStores_storeId_StatusApi,
    putStores_storeId_CategoriesApi,
    putMerchflowStorePogApi,
    putMerchflowBasePogApi,
    postMerchflowBasePog_basePogId_StatusApi,
    putMerchflowApprovalsApi,
    postMarkMerchflowStorePogsAsDeliveredApi,
    putMerchflows_merchflowId_MergeRulesApiV2,
    getS2SolutionsApi,
    getS2SolutionApi,
    putBasePogStatusApi,
    getStorePropStatusApi,
    downloadFlowUpdateExportApi,
    postMerchflowStartStorePlanogramsGenerationApi,
    postMerchflowStartStorePlanogramsCopyToStoresGenerationApi,
    getPowerBIReportApi,
    postImportEtlRunApi,
    getInputsProductsAllApi,
    putInputsProductsApi,
    getMerchflowByFilterConfigIdApi,
    getMerchflowS1PreLogsApi,
    getMerchflowS1LogsApi,
    getMerchflowS2LogsApi,
    getMerchflowBasePogLogsApi,
    getMerchflowStorePogLogsApi,
    getMerchflowStoreOriginalPsaDownloadUrlApi,
    getMerchflowStoreProductSyncLogDownloadUrlApi,
    getProjectsApi,
    postProjectsApi,
    putProjects_projectId_Api,
    getProjectApi,
    getTemplatesApi,
    getStoreProductsApi,
    putStoreProductsApi,
    getPreviousAssortmentApi,
    getPreviousAssortmentCandidatesApi,
    postMarkStorePogDeliveredApi,
    getTemplatesListApi,
    getMerchflowS0LogsApi,
    getMerchantSettingsApi,
    postImportJdaBaselineApi,
    getPowerBIWorkspaceReportsApi,
    putMerchantSettingsApi,
    postPowerBIWorkspaceApi,
    getCdtOrderApi,
    postStoresUpdateProductsApi,
    getCategories_categoryId_Stores_storeId_FixturesPogApi,
    postCategories_categoryId_Stores_storeId_FixturesPogApi,
    getCategories_categoryId_Api,
    getStores_storeId_Api,
    getFixturesGuessingPogApi,
    getFixturesGuessingApi,
    postFixturesGuessingApi,
    getFixturesGuessingLogsApi,
    getPogSummaryApi,
  };
};
